<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_hx flex-col">
                <my-menu class="sticky-menu" :default-active-index="2"></my-menu>
                <advisory-banner :imageUrl="aboutBanner"></advisory-banner>
                <div class="div_type_select">
                    <type-select :selected-index="0" @change="changeType" :key="`type-${Date.now()}-0`"></type-select>
                </div>
                <div class="div_content">
                    <div class="section_4 flex-row justify-between">
                        <div class="group_13 flex-col">
                            <div class="block_13 flex-row justify-between">
                                <div class="image-text_11 flex-row justify-between">
                                    <img
                                            class="label_1"
                                            referrerpolicy="no-referrer"
                                            src="../../assets/advisory/advisory_select_type1_02.png"
                                    />
                                    <span class="text-group_3">渠道风控管理</span>
                                </div>
                                <span class="text_18">Channel</span>
                            </div>
                            <img
                                    class="image_7"
                                    referrerpolicy="no-referrer"
                                    src="./assets/img/SketchPng058f619c4fb320f70ecaf25f56f7aeef8e86cb75e1a2bd6987e3454070ae04d8.png"
                            />
                            <div class="text-group_19 flex-col justify-between">
              <span class="text_19">
                作为医药领域渠道风控与合规管理服务的先行者之一，康柏汉森深耕行业近二十年，我们提供从常规核查到深度核查的创新风控管理解决方案，覆盖企业内部人员、经销商、药店及医院等多渠道多管理环节，助力客户破解渠道管理中的核心痛点。通过彻查问题并建立监督制约机制，提升销售数据的真实性和准确性，改善营销决策的有效性，优化渠道管理绩效，助力企业实现高效、透明的渠道运营与管理。
              </span>
                                <span class="text_20">核心产品：直连审核、经销商核查、终端核查、票据核查</span>
                            </div>
                        </div>
                        <div class="block_5_wraper">
                            <div class="block_5 flex-col" :style="{ backgroundImage: 'url(' + aboutImageUrl + ')' }"></div>
                        </div>

                    </div>
                    <core-select></core-select>
                    <solve-index></solve-index>
                    <!---->
                    <div class="section_10 flex-col">
                        <div class="block_6 flex-col" :style="{ backgroundImage: 'url(' + imgOrMp4 + ')' }"></div>
                    </div>
                    <div class="section_11 flex-col">
                        <div class="text-wrapper_5">
                            <span class="text_30">“数据驱动+行业深耕”</span>
                            <span class="paragraph_1"><br /></span>
                            <span class="text_31">-&nbsp;康柏汉森持续赋能企业构建风险可控、效率领先的渠道生态体系&nbsp;-</span>
                        </div>
                    </div>
                </div>

                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
            </div>
        </div>
        <div class="mobile-element">
            <div class="mobile-page flex-col">
                <mobile-header class="sticky-menu-mobile" :default-active-index="2"></mobile-header>
                <div class="mobile-link">
                    <mobile-link :default-active-index="2"></mobile-link>
                    <mobile-banner :contactBanner="aboutBanner"></mobile-banner>
                    <div class="div_type_select">
                        <mobile-type :selected-index="0" @change="changeType" key="mobile1"></mobile-type>
                    </div>
                    <mobile-introduce :introItem="introItem"></mobile-introduce>
                    <mobile-core :core-info="coreData"></mobile-core>
                    <mobile-solve-index></mobile-solve-index>
                    <div class="section_10_mobile flex-col">
                        <div class="block_6_mobile flex-col" :style="imgOrMp4Style"></div>
                    </div>
                    <div class="section_11_mobile flex-col">
                        <div class="text-wrapper_5_mobile">
                            <span class="text_30">“数据驱动+行业深耕”</span>
                            <span class="paragraph_1"><br /></span>
                            <span class="text_31">-&nbsp;康柏汉森持续赋能企业构建风险可控、效率领先的渠道生态体系&nbsp;-</span>
                        </div>
                    </div>
                </div>
                <mobile-footer @contactMobile="contactMobile"></mobile-footer>
                <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

            </div>
        </div>
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import advisoryBanner from "./childPage/advisoryBanner";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import typeSelect from "./childPage/typeSelect";
    import coreSelect from "./childPage/coreSelect";
    import solveIndex from "./childPage/solveIndex";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import TypeSelect from "./childPage/typeSelect";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileBanner from "./childPage/MobileBanner";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileType from "./childPage/MobileType";
    import MobileIntroduce from "./childPage/MobileIntroduce";
    import MobileCore from "./childPage/MobileCore";
    import MobileSolveIndex from "./childPage/MobileSolveIndex";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import {isNull} from "../../common/testFun";
    import commonFun from "@/util/common.js";

    export default {
        name: "advisoryIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"北京康柏汉森医，渠道风控管理"},
            ]
        },
        computed: {
            imgOrMp4Style() {
                return {
                    backgroundImage: `url(${this.imgOrMp4})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        data() {
            return {
                aboutBanner:require('@/assets/advisory/advisory_bj_02.png'),
                aboutImageUrl:require('@/assets/advisory/advisory_select_type1_01.png'),
                imgOrMp4: require('@/assets/advisory/advisory_index_solve01.png'),
                isVisible:true,
                isVisibleMobile:false,
                currentIndex: 0,
                introItem:{
                    title:'渠道风控管理',
                    enTitle:'Channel',
                    content:'作为医药领域渠道风控与合规管理服务的先行者之一，康柏汉森深耕行业近二十年，我们提供从常规核查到深度核查的创新风控管理解决方案，覆盖企业内部人员、经销商、药店及医院等多渠道多管理环节，助力客户破解渠道管理中的核心痛点。通过彻查问题并建立监督制约机制，提升销售数据的真实性和准确性，改善营销决策的有效性，优化渠道管理绩效，助力企业实现高效、透明的渠道运营与管理。',
                    production:'核心产品：直连审核、经销商核查、终端核查、票据核查',
                    img:require('@/assets/advisory/advisory_select_type1_01.png'),
                    labelIcon: require('@/assets/advisory/advisory_select_type1_02.png'),
                },
                //
                coreData: {
                    detailImg: require('../../assets/advisory/advisory_core_select01.png'),
                    items: [
                        {
                            icon: require('../../assets/home/chpc_about_industry_03.png'),
                            text: '行业创新实践沉淀',
                            content:'康柏汉森深耕渠道风控领域近二十年，作为国内早期专业服务开拓者，率先将国际核查标准与本土医药行业特性结合，形成覆盖“理念+方法论+工具+执行”的服务模式。通过100余家药械及大健康行业客户服务经验，已构建从基础数据核验到深度业务穿透的阶梯式解决方案库，持续引领行业服务标准升级。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_04.png'),
                            text: '全链路穿透能力',
                            content:'覆盖渠道业务通路全链条，针对企业内部人员、经销商、药店及诊所等环节，通过多源数据交叉验证（如DDI数据、流向数据、仓储数据、追溯信息），有效识别窜货、费用虚高、数据篡改等风险。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_05.png'),
                            text: '本土化动态风控能力',
                            content:'基于行业政策变化及区域商业实践的深度洞察，定期更新核查模型和方法论，提供符合市场环境的定制化风控策略；配合资深经验团队，高灵敏度识别区域差别导致的终端隐患。',
                        },
                        {
                            icon: require('../../assets/home/chpc_about_industry_06.png'),
                            text: '智能决策支持',
                            content:'依托自主研发的企业健康管理智慧中心，具备可视化经销商、产品、终端、进销存业务等的健康度评估及风险智能筛选能力，能够精准量化风险等级并提供优化建议，助力企业提升营销资源分配效率与ROI。',
                        }
                    ],
                }
            };
        },

        components:{
            MobileBanner,
            TypeSelect,
            myMenu,ChpcFooter,ContactFloat,ContactDialog,advisoryBanner,typeSelect,coreSelect,solveIndex,
            MobileHeader,MobileLink,MobileFooter,MobileType,MobileIntroduce,MobileCore,MobileSolveIndex,MobileContactDialog

        },
        mounted() {
            this.getPic();
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            changeType(index) {
                if(index == 0){
                    this.goto("Advisory");
                }else if(index == 1){
                    this.goto("compliance");
                }else if(index == 2){
                    this.goto("consultation");
                }
            },
            goto(url){
                url = '/' + url;
                this.$router.push(url);
            },
            getPic(){
                let pic ={model:3}
                this.$HTTP.getPicByModel(pic).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        if(data && data.length>0){
                            let picarr= commonFun.dealPic(data,1,false);
                            if(picarr && picarr.length>0){
                                this.aboutBanner = picarr;
                            }
                            let aboutImg = commonFun.dealPic(data,2,false);
                            if(!isNull(aboutImg)){
                                this.aboutImageUrl = aboutImg;
                            }
                            let aboutImg5 = commonFun.dealPic(data,5,false);
                            if(!isNull(aboutImg5)){
                                this.imgOrMp4 = aboutImg5;
                            }
                        }
                    }
                });
            }
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
